import React from 'react';
import { useAbility } from '../../contexts/AbilityContext';

const Can = ({ I, a, this: subject, children }) => {
    const ability = useAbility();

    if (!ability.can(I, subject ?? a)) {
        return null;
    }

    return <>{children}</>;
};

export default Can;